/** Super-admin: the bank-transfer reconciliation queue + payment details. */
import { request } from "./http";
import type { PaymentInfo } from "./store";

export interface PendingOrder {
  id: string;
  reference: string;
  tenant_id: string;
  tenant_name: string;
  pack_codes: string[];
  amount_minor: number;
  currency: string;
  status: string;
  created_at: string;
  paid_at: string | null;
}

export function listOrders(): Promise<PendingOrder[]> {
  return request("/platform/orders");
}

export function markOrderPaid(id: string): Promise<unknown> {
  return request(`/platform/orders/${id}/mark-paid`, { method: "POST" });
}

export function cancelOrder(id: string): Promise<unknown> {
  return request(`/platform/orders/${id}/cancel`, { method: "POST" });
}

export function getPaymentInfo(): Promise<PaymentInfo> {
  return request("/platform/payment-info");
}

export function updatePaymentInfo(values: Partial<PaymentInfo>): Promise<PaymentInfo> {
  return request("/platform/payment-info", { method: "PUT", body: values });
}
